import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9da5d52c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "exception-title" }
const _hoisted_2 = { class: "exception-subtitle" }


import { computed } from 'vue'
import GradientButton from '@remote/components/GradientButton.vue'
import { toast } from '@remote/utils'
import type { TEmptyType } from './type'

interface IProps {
  type: TEmptyType
  title?: string
  /** 空白文本，可做为someError的说明文字 */
  emptyText?: string
}
interface IEmits {
  (e: 'retry'): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    type: null,
    title: null,
    emptyText: null
  },
  emits: ["retry"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'retry'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  type: TEmptyType
  title?: string
  /** 空白文本，可做为someError的说明文字 */
  emptyText?: string
}





const data = computed(() => {
  switch (props.type) {
    case 'networkOffline': {
      return {
        icon: 'network-offline',
        title: '没有网络',
        subtitle: '请稍后重试',
        btnText: '点击重试',
      }
    }
    case 'noData': {
      return {
        icon: 'empty',
        title: '添加视频所在文件夹到个人片库吧～',
        subtitle: '',
        btnText: '',
      }
    }
    case 'notFound': {
      return {
        icon: 'not-found',
        title: '服务请求超时',
        subtitle: '请稍后重试',
        btnText: '点击重试',
      }
    }
    case 'timeout': {
      return {
        icon: 'error',
        title: '服务请求超时',
        subtitle: '请稍后重试',
        btnText: '点击重试',
      }
    }
    case 'someError': {
      return {
        icon: 'error',
        title: '出错了～',
        subtitle: props.emptyText || '',
        btnText: '点击重试',
      }
    }
    default: {
      return {
        icon: 'error',
        title: '出错了～',
        subtitle: props.emptyText || '',
        btnText: '',
      }
    }
  }
})

// function gotoWifiSettingPage () {
//   toast('功能待开发')
// }

function onButtonClick () {
  switch (props.type) {
    case 'networkOffline': {
      // gotoWifiSettingPage()
      emit('retry')
      return
    }
    case 'notFound':
    case 'timeout':
    case 'someError': {
      emit('retry')
      return
    }
    case 'noData':
    default: {
      return
    }
  }
}

function onPageClick () {
  switch (props.type) {
    case 'networkOffline': {
      // emit('retry')
      return
    }
    default: {
      return
    }
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "exception center",
    onClick: onPageClick
  }, [
    _renderSlot(_ctx.$slots, "picture", {}, () => [
      _createElementVNode("div", {
        class: _normalizeClass(["picture", _unref(data).icon])
      }, null, 2)
    ]),
    _createElementVNode("p", _hoisted_1, _toDisplayString(props.title || _unref(data).title), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(data).subtitle), 1),
    _renderSlot(_ctx.$slots, "extra", {}, () => [
      (_unref(data).btnText)
        ? (_openBlock(), _createBlock(GradientButton, {
            key: 0,
            class: "extra-button",
            text: _unref(data).btnText,
            onClick: _withModifiers(onButtonClick, ["stop"])
          }, null, 8, ["text", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})